import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChatbotConfig, SpfBucketFileFrontend } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { BotImportApiResponse } from '@shared-angular/services/bot-import.types';

type ShareTokenResponse = {
  botconfig: ChatbotConfig & { vectorStoreDirty: boolean },
  docs: SpfBucketFileFrontend[]
}
@Injectable({
  providedIn: 'root'
})
export class SharetokenService {

  constructor(private httpClient: HttpClient) { }

  public async getShareToken(botId: string) {
    try {
      return await firstValueFrom(this.httpClient.get<{ shareToken: string }>(`/api/toolbox/bot/admin/sharetoken/${botId}`));
    } catch (error) {
      console.error('Error while fetching share token', error);
      return '';
    }
  }

  public async getShareTokenInfo(token: string): Promise<ShareTokenResponse | undefined> {
    try {
      return (await firstValueFrom(this.httpClient.get<{ shareTokenInfo: ShareTokenResponse }>(`/api/toolbox/bot/admin/sharetokeninfo/${token}`))).shareTokenInfo;
    } catch (error) {
      console.error('Error while fetching share token info', error);
      return undefined;
    }
  }

  public async ImportBot(token: string): Promise<BotImportApiResponse<ChatbotConfig>> {
    try {
      return await firstValueFrom(this.httpClient.post<BotImportApiResponse<ChatbotConfig>>(`/api/toolbox/bot/admin/importfromsharetoken/${token}`, {}));
    } catch (error: unknown) {
      console.error('Error while fetching share token info', error);
      const payload = (error as { error?: BotImportApiResponse<ChatbotConfig> }).error;
      if (payload?.status === 'error') {
        return payload;
      }
      return { status: 'error', message: $localize`:@@import-error-generic:Der Import wurde abgebrochen. Es wurden keine Änderungen gespeichert.` };
    }
  }
}
